export default class reflexionesDePortafolioEvidenciasController{

    constructor($scope,$http,$mdDialog,locals,$timeout){

      const reflexionesDePortafolioEvidencias = this

       // $timeout( function(){
           $scope.data=locals.videoLinks
        // }, 1000 );
      


      reflexionesDePortafolioEvidencias.close = close

      function close() {
        $mdDialog.hide();
      }

 
  }
}

reflexionesDePortafolioEvidenciasController.$inject = ['$scope','$http','$mdDialog','locals','$timeout'];


// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/partials/review/summary/evaluacionDeProfesoresTemplates/dialogs/reflexionesDePortafolioEvidenciasController.js